import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NonEnrolledSessionPicker() {
  const navigate = useNavigate();
  const [availability, setAvailability] = useState({ june: false, july_august: false, september: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/non-enrolled/session-availability`)
      .then(r => setAvailability(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const anyOpen = availability.june || availability.july_august || availability.september;

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <button
        onClick={() => navigate("/")}
        className="absolute top-4 left-4 text-sm text-slate-500 hover:text-[#2B4C8C] transition-colors flex items-center gap-1"
        data-testid="ne-picker-back"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>
      <div className="w-full max-w-md space-y-6 text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_pool-lesson-book/artifacts/c9s2nl0s_rr%20logo.png"
          alt="Rolling River Day Camp"
          className="w-24 h-24 mx-auto"
        />
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#2B4C8C]">
          Rolling River Day Camp
        </h1>
        <p className="text-slate-600 text-lg">Non-Enrolled Swim Lessons</p>

        {loading ? (
          <p className="text-slate-400">Loading…</p>
        ) : !anyOpen ? (
          <div className="pt-4" data-testid="ne-no-sessions-open">
            <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 text-slate-700">
              <p className="font-bold text-[#2B4C8C] mb-2">Enrollment Closed</p>
              <p className="text-sm">Non-enrolled swim lesson registration is currently closed. Please check back soon for the next session.</p>
            </div>
          </div>
        ) : (
          <div className="space-y-4 pt-4">
            {availability.june && (
              <button
                data-testid="ne-session-june"
                onClick={() => navigate("/non-enrolled/register?session=june")}
                className="w-full py-5 px-6 rounded-2xl bg-[#D4A843] hover:bg-[#b8902e] text-white font-bold text-lg transition-all shadow-lg hover:shadow-xl"
              >
                June Lessons
                <span className="block text-sm font-normal opacity-80 mt-1">During the Month of June</span>
              </button>
            )}

            {availability.july_august && (
              <button
                data-testid="ne-session-july-august"
                onClick={() => navigate("/non-enrolled/register?session=july_august")}
                className="w-full py-5 px-6 rounded-2xl bg-[#2B4C8C] hover:bg-[#1e3666] text-white font-bold text-lg transition-all shadow-lg hover:shadow-xl"
              >
                July-August Lessons
                <span className="block text-sm font-normal opacity-80 mt-1">Monday Through Friday</span>
              </button>
            )}

            {availability.september && (
              <button
                data-testid="ne-session-september"
                onClick={() => navigate("/non-enrolled/register?session=september")}
                className="w-full py-5 px-6 rounded-2xl bg-rose-700 hover:bg-rose-800 text-white font-bold text-lg transition-all shadow-lg hover:shadow-xl"
              >
                September Lessons
                <span className="block text-sm font-normal opacity-80 mt-1">Off-Season Make-Ups</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
